module.exports = __webpack_public_path__ + "img/bannerAgence.567e267b.jpg";